import { getQueryClient } from "@/lib/providers/TanstackQueryProvider";
import { APIClient } from "@starsoft/common/services";

const commonInstance = new APIClient(
  process.env.NEXT_PUBLIC_BASE_API,
  process.env.NEXT_PUBLIC_TENANT_ID,
  undefined,
  getQueryClient(),
  false,
);
const baseAPI = commonInstance.instance;

export default baseAPI;
